export const AEPS_BALANCEENQUIRY = 4;
export const AEPS_CASHWITHDRAW = 5;
export const AEPS_MINISTATEMENT = 9;
export const AEPS_AADHARPAY = 11;
export const CONSUMER_LOAN = 2;
export const RETAILER_LOAN = 3;
